import ItemPromotionService from '@/services/admin/itemPromotion.service'
import router from '@/router'

const state =  {
}

const getters = {
}

const actions = {
    //----------------------Promotion ----------------
    async searchItemPromotionAdvanced({commit}, payload) {
        try {
            console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemPromotionService.searchItemPromotionAdvanced(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
    async saveItemPromotion({commit}, payload) {
        try {
            console.log(payload)
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemPromotionService.saveItemPromotion(payload);
            return result
        } catch (e) {
            // console.log(e)
            return e
        } finally {
            commit('setLoading', false, { root: true })

        }
    },
 
    //---------------------- End Promotion -----------------------------
}

const mutations = {
}

export const adminItemPromotion = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}